import { SET_PRICES, SET_PRICE_PLANS, SET_PRODUCT, SET_PRODUCTS } from "../../constants/productConstants";

const initialState = {
  product: null,
  products: [],
  allProducts: [],
  services: [],
  filteredProducts: [],
  filteredServices: [],
  pricePlans: [],
  prices: [],
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCT:
      return {
        ...state,
        product: action.product,
      };
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.isProduct && !action.filtered ? action.products : state.products,
        allProducts: action.isProduct && action.all ? action.products : state.allProducts,
        filteredProducts: action.isProduct && action.filtered ? action.products : state.filteredProducts,
        services: !action.isProduct && !action.filtered ? action.products : state.services,
        filteredServices: !action.isProduct && action.filtered ? action.products : state.filteredServices,
      };
    case SET_PRICE_PLANS:
      return {
        ...state,
        pricePlans: action.pricePlans,
      };
    case SET_PRICES:
      return {
        ...state,
        prices: action.prices,
      };
    default:
      return state;
  }
};

export default productReducer;
